import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export default function DeleteDialog({ openDelete, setOpenDelete, handleOk }) {
  return (
    <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
      <DialogTitle>እርግጠኛ ነዎት ይህን መልእክት መሰረዝ ይፈልጋሉ?</DialogTitle>
      <DialogContent>
        <DialogContentText>ይህ እርምጃ ሊቀለበስ አይችልም።</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenDelete(false)}>ተመለስ</Button>
        <Button color="error" variant="contained" onClick={handleOk} autoFocus>
          ሰርዝ
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeleteDialog.propTypes  = {
  openDelete: PropTypes.bool.isRequired,
  setOpenDelete: PropTypes.func.isRequired,
  handleOk: PropTypes.func.isRequired,
}